import type { GeocodingFeature } from '../../types';

const isAddressFeature = (feature: GeocodingFeature): boolean => {
  const featureType = feature.properties.feature_type;
  return featureType === 'address' || featureType === 'secondary_address';
};

export default isAddressFeature;
